export default "__VITE_ASSET__BOnwnpe$__";